import React from "react";
import { ConversationExporterButton } from "./components/ConversationExporterButton";
import { ConversationExporterPopup } from "./components/ConversationExporterPopup";
import { ConversationExporterState, useConversationExporterContextSafe } from "./context/ConversationExporterContext";

interface Props {
  disabled?: boolean;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
  isInside: boolean;
  /**
   * Explicit state wins over the provider's — lets another product (Athena)
   * mount the same button + popup driven by its own feature resolution and
   * export endpoint, while Bonds keeps the context wiring untouched.
   */
  state?: ConversationExporterState;
}

export const ConversationExporter: React.FC<Props> = ({ onMouseEnter, onMouseLeave, isInside, disabled = false, state }) => {
  const fromContext = useConversationExporterContextSafe(); // always called; explicit state wins
  const resolved = state ?? fromContext;
  if (!resolved) {
    throw new Error("ConversationExporter: render inside a ConversationExporterProvider or pass `state`");
  }
  const { isEnabled, isPopupOpen, isLoading, openPopup, closePopup, handleExport } = resolved;

  if (!isEnabled) {
    return null;
  }

  return (
    <>
      <ConversationExporterButton
        onClick={openPopup}
        disabled={disabled || isLoading}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        isInside={isInside}
      />
      <ConversationExporterPopup isOpen={isPopupOpen} onClose={closePopup} onExport={handleExport} isLoading={isLoading} />
    </>
  );
};
